// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__MICAZ","author_img":"styles_author_img__Q5zgE","stars":"styles_stars__Uk8vi","author":"styles_author__basgm"};